(() => {
  const MOBILE_BREAKPOINT = 768;
  const SECTION_TITLES = ["Men's Sizing", "Women's Sizing"];
  const canonicalMap = [
    { match: /us/i, id: "US", label: "US" },
    { match: /\bau\b|australia/i, id: "AU", label: "AU (Australia)" },
    { match: /\bcm\b|japan/i, id: "CM", label: "CM (Japan)" },
    { match: /\beu\b|europe/i, id: "EU", label: "EU (Europe)" },
    { match: /\buk\b/i, id: "UK", label: "UK" }
  ];

  function addStyles() {
    if (document.getElementById("oszea-size-styles")) return;
    const css = `
.oszea-table { width: 100%; border-collapse: collapse; margin: 12px 0; font-size: 14px; }
.oszea-table th, .oszea-table td { border: 1px solid #e0e0e0; padding: 8px 10px; text-align: center; }
.oszea-table th { background:#f7f7f7; font-weight:700; }
.oszea-size-wrapper .oszea-mobile-only { display: none; }
@media (max-width: ${MOBILE_BREAKPOINT}px) {
  .oszea-size-wrapper .oszea-desktop-only { display: none; }
  .oszea-size-wrapper .oszea-mobile-only { display: block; }
}
`;
    const s = document.createElement("style");
    s.id = "oszea-size-styles";
    s.appendChild(document.createTextNode(css));
    document.head.appendChild(s);
  }

  function findHeading(root, title) {
    const heads = Array.from(root.querySelectorAll("h1,h2,h3,h4,h5,h6"));
    return heads.find(h => h.textContent.trim().toLowerCase().includes(title.toLowerCase()));
  }

  function collectSectionNodes(startHeading) {
    const nodes = [];
    let el = startHeading ? startHeading.nextElementSibling : null;
    while (el && !/^H[1-6]$/.test(el.tagName)) {
      nodes.push(el);
      el = el.nextElementSibling;
    }
    return nodes;
  }

  function splitLinesFromNodes(nodes) {
    const lines = [];
    nodes.forEach(n => {
      const raw = (n.innerText || n.textContent || "").trim();
      if (!raw) return;
      raw.split(/\r?\n/).forEach(l => {
        const t = l.trim();
        if (t) lines.push(t);
      });
    });
    return lines;
  }

  function parseRows(lines) {
    const rows = [];
    lines.forEach(line => {
      const tokens = line.split(/\s+/).filter(Boolean);
      const firstNum = tokens.findIndex(tok => /^\d/.test(tok));
      if (firstNum === -1) return;
      const label = tokens.slice(0, firstNum).join(" ");
      const values = tokens.slice(firstNum);
      const found = canonicalMap.find(c => c.match.test(label));
      const key = found ? found.id : label;
      const display = found ? found.label : label;
      rows.push({ rawLabel: label, key, display, values });
    });
    const orderIds = ["US", "AU", "CM", "EU", "UK"];
    const ordered = [];
    orderIds.forEach(id => {
      const f = rows.find(r => r.key === id);
      if (f) ordered.push(f);
    });
    rows.forEach(r => { if (!ordered.includes(r)) ordered.push(r); });
    return ordered;
  }

  function buildDesktopTable(rows) {
    const table = document.createElement("table");
    table.className = "oszea-table oszea-desktop-table";
    const tbody = document.createElement("tbody");
    rows.forEach(r => {
      const tr = document.createElement("tr");
      const th = document.createElement("th");
      th.textContent = r.display;
      tr.appendChild(th);
      r.values.forEach(v => {
        const td = document.createElement("td");
        td.textContent = v;
        tr.appendChild(td);
      });
      tbody.appendChild(tr);
    });
    table.appendChild(tbody);
    return table;
  }

  function buildMobileTable(rows) {
    const table = document.createElement("table");
    table.className = "oszea-table oszea-mobile-table";
    const thead = document.createElement("thead");
    const headRow = document.createElement("tr");
    rows.forEach(r => {
      const th = document.createElement("th");
      th.textContent = r.display;
      headRow.appendChild(th);
    });
    thead.appendChild(headRow);
    table.appendChild(thead);

    const maxCols = Math.max(...rows.map(r => r.values.length), 0);
    const tbody = document.createElement("tbody");
    for (let i = 0; i < maxCols; i++) {
      const tr = document.createElement("tr");
      rows.forEach(r => {
        const td = document.createElement("td");
        td.textContent = r.values[i] || "";
        tr.appendChild(td);
      });
      tbody.appendChild(tr);
    }
    table.appendChild(tbody);
    return table;
  }

  function insertTablesAfterHeading(heading, desktopTable, mobileTable, originalNodes) {
    const wrapper = document.createElement("div");
    wrapper.className = "oszea-size-wrapper";
    const desktopWrap = document.createElement("div");
    desktopWrap.className = "oszea-desktop-only";
    desktopWrap.appendChild(desktopTable);
    const mobileWrap = document.createElement("div");
    mobileWrap.className = "oszea-mobile-only";
    mobileWrap.appendChild(mobileTable);
    wrapper.appendChild(desktopWrap);
    wrapper.appendChild(mobileWrap);
    const refNode = originalNodes.length ? originalNodes[originalNodes.length - 1].nextSibling : heading.nextSibling;
    heading.parentNode.insertBefore(wrapper, refNode);
    originalNodes.forEach(n => n.parentNode && n.parentNode.removeChild(n));
  }

  function rebuildSizeGuide(root = document) {
    if (!root) return;
    addStyles();
    SECTION_TITLES.forEach(title => {
      const heading = findHeading(root, title);
      if (!heading) return;
      const nodes = collectSectionNodes(heading);
      if (!nodes.length) return;
      const lines = splitLinesFromNodes(nodes);
      if (!lines.length) return;
      const parsed = parseRows(lines);
      if (!parsed.length) return;
      const desktopTable = buildDesktopTable(parsed);
      const mobileTable = buildMobileTable(parsed);
      insertTablesAfterHeading(heading, desktopTable, mobileTable, nodes);
    });
  }

  // Run on load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => rebuildSizeGuide(document));
  } else {
    rebuildSizeGuide(document);
  }

  // Watch for the popup modal
  const observer = new MutationObserver(mutations => {
    mutations.forEach(m => {
      m.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          // Look for the size guide modal container
          if (node.matches('.size-chart, .modal, .Popup, .drawer') || node.querySelector('h2,h3,h4')) {
            if (/sizing/i.test(node.textContent)) {
              rebuildSizeGuide(node);
            }
          }
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
